export default __webpack_public_path__ + "static/media/mobile_app.9211597c.cdz";